const isEmpty = obj => {
    return Object.keys(obj).length === 0;
};

/**
 * Extract meaningful error message from API response
 * @param {Object} error - The error object from API call
 * @returns {string} - Human-readable error message
 */
const extractApiErrorMessage = (error) => {
    // Extract meaningful error message from API response
    if (error.response && error.response.data) {
        const errorData = error.response.data;
        
        // Check for specific error message fields
        if (errorData.message) {
            return errorData.message;
        }
        if (errorData.error) {
            return errorData.error;
        }
        if (errorData.detail) {
            return errorData.detail;
        }
        if (errorData.errors) {
            // Handle validation errors
            if (Array.isArray(errorData.errors)) {
                return errorData.errors.join(', ');
            }
            if (typeof errorData.errors === 'object') {
                return Object.values(errorData.errors).flat().join(', ');
            }
        }
        
        // Fallback to generic error data
        if (typeof errorData === 'string') {
            return errorData;
        }
    }
    
    // Check if there's a message in the main error object
    if (error.message) {
        return error.message;
    }
    
    // Default fallback
    return 'An unexpected error occurred. Please try again.';
};

export { isEmpty, extractApiErrorMessage };
